import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreUiModule } from '@pos-app/core-ui';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatBadgeModule } from '@angular/material/badge';
import { CentralComponent } from './central.component';
import { ProductInfoBulletinEmailComponent } from './components/product-info-bulletin-email/product-info-bulletin.component';
import { NgxMaskModule } from 'ngx-mask';
import { InternalBulletinEmailComponent } from './components/internal-bulletin-email/internal-bulletin-email.component';
import { CentralNotificationComponent } from './components/notification/central-notification.component';
import { HelpHowToComponent } from './components/help-how-to/help-how-to.component';
import { AgGridModule } from 'ag-grid-angular';
import { StoreModule } from '@ngrx/store';
import * as fromCentral from './+state/central.reducer';
import { EffectsModule } from '@ngrx/effects';
import { CentralEffects } from './+state/central.effects';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { NgSelectModule } from '@ng-select/ng-select';
import { TaskComponent } from './components/task/containers/task.component';
import { MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { HelpYouSellComponent } from './components/help-you-sell/help-you-sell.component';
import { TaskGridActionRendererComponent } from './components/task/taskActionRender/TaskGridActionRendererComponent';
import { CentralTaskGridActionRendererComponent } from './components/task/components/task-detail/CentralTaskGridActionRendererComponent';
import { TaskDetailComponent } from './components/task/components/task-detail/task-detail.component';
import { TaskNavComponent } from './components/task/components/task-nav/task-nav.component';
import { NewTaskComponent } from './components/task/components/task-new/task-new.component';
import { OpenTaskComponent } from './components/task/components/task-open/task-open.component';
import { ClosedTaskComponent } from './components/task/components/task-close/task-closed.component';
import { CentralRoutingModule } from './central-routing.module';
import { ManageHelpComponent } from './components/manage-help-component/manage-help-component.component';

@NgModule({
    imports: [
        MatBadgeModule,
        CommonModule,
        NgbModule,
        MatIconModule,
        FormsModule,
        AgGridModule,
        ReactiveFormsModule,
        CoreUiModule,
        NgbModalModule,
        NgSelectModule,
        MatDatepickerModule,
        AngularEditorModule,
        CentralRoutingModule,
        StoreModule.forFeature(fromCentral.CENTRAL_FEATURE_KEY, fromCentral.reducer),
        EffectsModule.forFeature([CentralEffects]),
        ProductInfoBulletinEmailComponent,
        InternalBulletinEmailComponent,
        CentralNotificationComponent,
        HelpHowToComponent,
        CentralTaskGridActionRendererComponent,
        TaskComponent,
        TaskGridActionRendererComponent,
        HelpYouSellComponent,
        TaskDetailComponent,
        TaskNavComponent,
        NewTaskComponent,
        OpenTaskComponent,
        ClosedTaskComponent,
        ManageHelpComponent,
        CentralComponent,
        NgxMaskModule.forRoot({
            validation: false,
        }),
    ],
    declarations: [
    ],
    providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class CentralModule {}

